import { useState } from "react";

import { Icon, IconButton, Stack } from "@mui/material";
import MDButton from "components/MDButton";

import { setDataConfig, useMaterialUIController } from "context";

import { keyLocalStorage } from "helpers/constants";

import { deleteModalidade } from "services/modalidade";

interface Props {
  listModalidade: any[];
  itemDeleted: any;
}
export default function RemoverModalidade({
  listModalidade,
  itemDeleted,
}: Props): JSX.Element {
  const [controller, dispatch] = useMaterialUIController();
  const { dataConfig } = controller;
  const [confirmed, setConfirmed] = useState<boolean>(false);

  const handleRemoverModalidade = async () => {
    setConfirmed(false);
    const newListModalidade = listModalidade.filter(
      (item) => item.id !== itemDeleted.id,
    );
    await deleteModalidade(itemDeleted.id);
    const data = { ...dataConfig, modalidade: newListModalidade };
    setDataConfig(dispatch, data);
    localStorage.setItem(
      keyLocalStorage.DEFAULT_CONSTANTS,
      JSON.stringify(data),
    );
  };
  return (
    <>
      {!confirmed ? (
        <IconButton
          size="small"
          edge="end"
          aria-label="delete"
          onClick={(e) => {
            e.stopPropagation();
            setConfirmed(true);
          }}
        >
          <Icon color="error" fontSize="small">
            delete_outline
          </Icon>
        </IconButton>
      ) : (
        <Stack
          direction="row"
          spacing={0.5}
          alignItems="center"
          onClick={(e) => e.stopPropagation()}
        >
          <MDButton
            variant="outlined"
            color="success"
            size="small"
            onClick={() => void handleRemoverModalidade()}
            sx={{ minWidth: 0, px: 1, py: 0.25, fontSize: "0.7rem" }}
          >
            Sim
          </MDButton>
          <MDButton
            variant="outlined"
            color="error"
            size="small"
            onClick={() => setConfirmed(false)}
            sx={{ minWidth: 0, px: 1, py: 0.25, fontSize: "0.7rem" }}
          >
            Não
          </MDButton>
        </Stack>
      )}
    </>
  );
}
